import styled from '@emotion/styled'

export const Flex = styled.div(
  {
    display: 'flex'
  },
  props => (props.flex ? { flex: props.flex } : {}),
  props => (props.flexDirection ? { flexDirection: props.flexDirection } : {}),
  props => (props.alignItems ? { alignItems: props.alignItems } : {}),
  props => (props.justifyContent ? { justifyContent: props.justifyContent } : {}),
  props => (props.width ? { width: props.width } : {}),
  props => (props.height ? { height: props.height } : {})
)
